'use strict';

export default class Topbar {
    constructor() {
        //for taking a survey, after the survey is done, user can go back to fine listing page and seeing the survey is completed
        if (window.location.href.indexOf("IsSurveyCompleted=true") > -1) {
            var confirmation = '<div class="row after-survey">'
                + '<p>Thanks for taking the survey</p>'
                + '<div class="btngroup">'
                + '<button href="" class="btn hidebtn">Hide</button>'
                + '</div>'
                + '</div>';
            $('.personalisation_container .topbar.survey .wrapper').each(function () {

                var actionButton = $(this).find('.btngroup a.action');
                if (actionButton.attr('href') === '/Survey') {
                    $(this).append(confirmation);
                    $(this).children('.row').css('display', 'none');
                    $(this).find('.after-survey').css('display', 'flex');
                }
            });
        }

        $('.hidebtn').on("click", function () {
            $(this).parents('.topbar').slideToggle(60, function () {
                $(this).remove();
            });
        });

        if ($('section').hasClass('topbar')) {
            $('.oneHundy').css('padding-top', '42px');
        }
    }
}